import {
  AUDIENCE_TYPE,
  INVENTORY_CATALOG,
  INVENTORY_TYPE,
  UNIOIN_VIDEO_TYPE,
  REGION_TYPE,
  LOCATION_TYPE,
  GENDER_TYPE,
  AGE_TYPES,
  INTEREST_ACTION_TYPES,
  PLATFORM,
  HIDE_IF_CONVERTED,
  CONVERTED_TIME_DURATION,
  HIDE_IF_EXISTS,
  DEVICE_TYPE,
  DEVICE_TYPE_CATEGORY,
  AUTO_EXTEND_ENABLE,
  AC,
  SUPERIOR_POPULARITY_TYPE,
  CARRIER_TYPE,
  ACTIVATE_TYPE,
  BRAND_TYPE,
  PRICE_TYPE
} from './toutiao_targeting_consts'

export const getToutiaoTargetingForm = (account) => {
  const audiences = {}

  if (account?.id) {
    audiences[account.id] = {
      accountId: account.id,
      includes: [],
      excludes: []
    }
  }
  return {
    inventory_catalog: INVENTORY_CATALOG.MANUAL, // 投放位置
    inventory_type: [
      INVENTORY_TYPE.INVENTORY_FEED,
      INVENTORY_TYPE.INVENTORY_VIDEO_FEED,
      INVENTORY_TYPE.INVENTORY_AWEME_FEED,
      INVENTORY_TYPE.INVENTORY_TOMATO_NOVEL,
      INVENTORY_TYPE.INVENTORY_UNION_SLOT,
      INVENTORY_TYPE.UNION_BOUTIQUE_GAME
    ], // 投放位置-广告位大类
    union_video_type: UNIOIN_VIDEO_TYPE.REWARDED_VIDEO, // 投放形式

    audienceType: AUDIENCE_TYPE.UNLIMITED, // 是否开启人群包定向
    // 人群定向model结构
    // audiences: {
    //   17778: {
    //     accountId: 17778,
    //     includes: [],
    //     excludes: []
    //   }
    // },
    audiences,

    regionType: REGION_TYPE.UNLIMITED, // 是否开启地区定向
    region: [], // 地区定向
    location_type: LOCATION_TYPE.HOME,

    gender: GENDER_TYPE.UNLIMITED, // 性别定向

    age: [AGE_TYPES.UNLIMITED], // 年龄定向
    moreAge: [], // 年龄定向
    interest_action_mode: INTEREST_ACTION_TYPES.UNLIMITED, // 兴趣行为定向

    platform: PLATFORM.UNLIMITED, // 平台
    android_osv: '', // 安卓系统版本
    ios_osv: '', // ios系统版本
    harmony_osv: '', // 鸿蒙系统版本

    word_tags: [],
    action_categories: [],
    action_words: [],

    action_tags: [],
    action_scene: [],
    action_days: 30,

    hide_if_converted: HIDE_IF_CONVERTED.NO_EXCLUDE, // 过滤已转化
    converted_time_duration: CONVERTED_TIME_DURATION.NONE, // 过滤时间
    hide_if_exists: HIDE_IF_EXISTS.UNLIMITED, // 已安装用户
    device_type: [DEVICE_TYPE_CATEGORY.UNLIMITED],

    auto_extend_enabled: AUTO_EXTEND_ENABLE.OFF, // 是否开启智能放量
    autotend: [], // 智能放量

    ac: [AC.NONE], // 网络类型

    // 穿山甲媒体定向, 该字段不需要传到媒体后台，只需要做类型切换
    superior_popularity_type: SUPERIOR_POPULARITY_TYPE.UNLIMITED,

    carrier: [CARRIER_TYPE.UNLIMITED], // 运营商
    activate_type: [ACTIVATE_TYPE.UNLIMITED], // 新用户
    brand_type: BRAND_TYPE.UNLIMITED,
    brand: [],

    price_type: PRICE_TYPE.UNLIMITED, // 是否开启价格区间过滤
    launch_price: [0, 11000] // 价格区间
  }
}
